module.exports = __webpack_public_path__ + "static/media/preguntas_datos_cedula.89cd0830.svg";